import { TechSpaceErrorType } from "./index98.js";
import { errorHandler } from "./index101.js";
function implementSizeConstraints(sizeInfo, maxHeight, maxDepth, forceInvalid = false) {
	const area = sizeInfo.area;
	const sizeX = sizeInfo.sizeX;
	let sizeY = sizeInfo.sizeY;
	let sizeZ = sizeInfo.sizeZ;
	let invalidated = false;
	if (maxHeight >= sizeInfo.sizeY[0]) sizeY = [Math.min(maxHeight, sizeInfo.sizeY[1]), Math.min(maxHeight, sizeInfo.sizeY[1])];
	else if (forceInvalid) {
		sizeY = [maxHeight, maxHeight];
		invalidated = true;
	} else return {
		success: false,
		error: errorHandler(TechSpaceErrorType.Size, {
			errorDimension: "SizeY",
			spaceRequired: sizeInfo,
			invalidatedSize: false
		})
	};
	if (maxDepth >= sizeInfo.sizeZ[0]) sizeZ = [sizeInfo.sizeZ[0], Math.min(maxDepth, sizeInfo.sizeZ[1])];
	else if (forceInvalid) {
		sizeZ = [maxDepth, maxDepth];
		invalidated = true;
	} else return {
		success: false,
		error: errorHandler(TechSpaceErrorType.Size, {
			errorDimension: "SizeZ",
			spaceRequired: sizeInfo,
			invalidatedSize: false
		})
	};
	return {
		success: true,
		size: {
			area,
			sizeX,
			sizeY,
			sizeZ
		},
		invalidated
	};
}
export { implementSizeConstraints };

//# sourceMappingURL=index116.js.map